import { soulforgeAPI } from '../systems/SoulforgeAPI.js';

export class EndScreen {
  constructor() {
    this.container = null;
    this.init();
  }

  init() {
    // Create the end screen container
    this.container = document.createElement('div');
    this.container.id = 'endScreen';
    this.container.style.display = 'none';

    // Set the inner HTML for the end screen modal
    this.container.innerHTML = `
      <div id="endScreenModal">
        <div id="winnerMessage"></div>
        <div id="endScreenContent">
          <div id="statsContainer">
            <h2>Game Statistics</h2>
            <table id="statsTable">
              <thead>
                <tr>
                  <th>Team</th>
                  <th>Kills</th>
                  <th>Units</th>
                </tr>
              </thead>
              <tbody>
                <!-- Stats rows will be populated by the show method -->
              </tbody>
            </table>
          </div>
          <div id="sessionInfo" style="margin: 10px 0; font-size: 14px; color: #999; display: none;">
            <div>Session: <span id="sessionId" style="color: #0f0; font-family: monospace;"></span></div>
          </div>
          <div id="commentaryContainer">
            <h2>AI Commentary</h2>
            <p id="commentaryText">Analyzing battle data...</p>
          </div>
        </div>
        <div style="display: flex; gap: 10px; justify-content: center;">
          <button id="viewSessionBtn" style="display: none;">VIEW SESSION</button>
          <button id="restartBtn">RESTART GAME</button>
        </div>
      </div>
    `;

    document.body.appendChild(this.container);
  }

  show(team, stats, onRestart, forgeSessionInfo = null) {
    const winnerMessageEl = this.container.querySelector('#winnerMessage');
    const restartBtn = this.container.querySelector('#restartBtn');
    const viewSessionBtn = this.container.querySelector('#viewSessionBtn');
    const sessionIdSpan = this.container.querySelector('#sessionId');
    const sessionInfoDiv = this.container.querySelector('#sessionInfo');
    const modal = this.container.querySelector('#endScreenModal');
    const tableBody = this.container.querySelector('#statsTable tbody');

    if (winnerMessageEl) {
      winnerMessageEl.textContent = `${team.name.toUpperCase()} TEAM WINS!`;
      winnerMessageEl.style.color = team.color;
    }

    if (modal) {
      modal.style.borderColor = team.color;
      modal.style.boxShadow = `0 0 30px ${team.color}`;
    }

    // Display session info if provided
    if (forgeSessionInfo && sessionIdSpan && sessionInfoDiv) {
      sessionIdSpan.textContent = forgeSessionInfo.sessionId || 'Unknown';
      sessionInfoDiv.style.display = 'block';
    }

    if (restartBtn) {
      restartBtn.onclick = onRestart;
      restartBtn.style.borderColor = team.color;
      restartBtn.style.color = team.color;
    }

    // Set up view session button
    if (viewSessionBtn && forgeSessionInfo && forgeSessionInfo.id) {
      viewSessionBtn.style.display = 'inline-block';
      viewSessionBtn.style.borderColor = team.color;
      viewSessionBtn.style.color = team.color;
      viewSessionBtn.onclick = () => {
        window.open(`http://localhost:4001/forge_sessions/${forgeSessionInfo.id}`, '_blank');
      };
    }

    // Populate stats table
    if (tableBody) {
        tableBody.innerHTML = ''; // Clear previous stats
        stats.forEach(stat => {
            const row = document.createElement('tr');
            if (stat.name === team.name) {
                row.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';
                row.style.boxShadow = `inset 0 0 10px ${team.color}`;
            }

            row.innerHTML = `
                <td style="color: ${stat.color};">${stat.name}</td>
                <td>${stat.kills}</td>
                <td>${stat.units}</td>
            `;
            tableBody.appendChild(row);
        });
    }

    // Fetch and display commentary
    const commentaryTextEl = this.container.querySelector('#commentaryText');
    if (commentaryTextEl) {
        commentaryTextEl.textContent = 'Analyzing battle data...';
        soulforgeAPI.getGameCommentary(team, stats)
            .then(commentary => {
                commentaryTextEl.textContent = commentary;
            })
            .catch(error => {
                console.error('Error fetching commentary:', error);
                commentaryTextEl.textContent = 'Could not retrieve commentary.';
            });
    }

    this.container.style.display = 'flex';
  }

  hide() {
    this.container.style.display = 'none';
  }
}